import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-explicit-any */
import { zodResolver } from "@hookform/resolvers/zod";
import { CatAccordion } from "blocks-nextjs/blocks-react/components/Accordion/Accordion";
import { CatAccordionPanel } from "blocks-nextjs/blocks-react/components/AccordionPanel/AccordionPanel";
import { CatButton } from "blocks-nextjs/blocks-react/components/Button/Button";
import { CatDropdown } from "blocks-nextjs/blocks-react/components/Dropdown/Dropdown";
import { CatHeading } from "blocks-nextjs/blocks-react/components/Heading/Heading";
import { CatIconAddCircle } from "blocks-nextjs/blocks-react/components/Icons/AddCircle/AddCircle";
import { CatIconEdit } from "blocks-nextjs/blocks-react/components/Icons/Edit/Edit";
import { CatIconTrash } from "blocks-nextjs/blocks-react/components/Icons/Trash/Trash";
import { CatInputField } from "blocks-nextjs/blocks-react/components/InputField/InputField";
import { CatList } from "blocks-nextjs/blocks-react/components/List/List";
import { CatListItem } from "blocks-nextjs/blocks-react/components/ListItem/ListItem";
import { CatTextareaField } from "blocks-nextjs/blocks-react/components/TextareaField/TextareaField";
import { useEffect, useState } from "react";
import React from "react";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { z } from "zod";
import { NewProjectSteps } from "../../pages/Projects/NewProjectPage";
import { CaasRoute } from "../../routes";
import { useCreateProjectGeofenceMutate, useDeleteProjectGeofenceMutate, useGetProjectGeofenceDetailsQuery, useUpdateProjectGeofenceMutate } from "../../services/query/geofence.query";
import { useUpdateProjectDetailsMutate } from "../../services/query/update-project-details.query";
import useAppConfigStore from "../../store/useAppConfigStore";
import useGlobalStore from "../../store/useGlobalStore";
import useNewProjectStore from "../../store/useNewProjectStore";
import useProjectGeoFenceStore from "../../store/useProjectGeoFenceStore";
import { GeofenceOperationType } from "../../swagger/caas-v1/models/GeofenceOperationType";
import { GeofenceType } from "../../swagger/caas-v1/models/GeofenceType";
import { Variant } from "../GlobalNotification/GlobalNotification";
import { getGeofenceTypeName } from "../GoogleMaps/GeoFence.helper";
import GoogleMapGeoFence, { POLYGON_TYPES } from "../GoogleMaps/GoogleMapGeoFence";
import "./AddEditGeoFenceForm.css";
import NewProjectModal from "./NewProjectModal";
import { prepareCreateGeoFenceRequest, prepareUpdateGeoFenceRequest } from "./ProjectGeoFence.helper";
const MIN_GEOFENCE_NAME_LENGTH = 3;
const DUPLICATE_NAME_ERROR = "Geofence name already exists. Please choose a different name.";
const GEOFENCE_TYPE_PROJECT_AREA = "projectArea";
const GEOFENCE_TYPE_JOB_SITE = "jobSite";
const GEOFENCE_TYPE_CHARGE_STATION = "chargeStation";
const GEOFENCE_TYPE_NONE = "none";
const PROJECT_STATUS_PENDING = "PENDING";
const PROJECT_STATUS_ACTIVE = "ACTIVE";
const MODE_TYPE_ADD = "add";
const MODE_TYPE_EDIT = "edit";
const FIRST_GEOFENCE_INDEX = 0;
const MIN_NAME_DISPLAY_LENGTH = 1;
export var GeoFenceActionType;
(function (GeoFenceActionType) {
    GeoFenceActionType["ACTIVE_PROJECT_GEOFENCE_CREATE"] = "ActiveProjectCreate";
    GeoFenceActionType["ACTIVE_PROJECT_GEOFENCE_DELETE"] = "ActiveProjectDelete";
    GeoFenceActionType["ACTIVE_PROJECT_GEOFENCE_META_DATA_UPDATE"] = "ActiveProjectMetaDataUpdate";
    GeoFenceActionType["ACTIVE_PROJECT_GEOFENCE_UPDATE"] = "ActiveProjectUpdate";
    GeoFenceActionType["PENDING_PROJECT_GEOFENCE_CREATE"] = "PendingProjectCreate";
    GeoFenceActionType["PENDING_PROJECT_GEOFENCE_DELETE"] = "PendingProjectDelete";
    GeoFenceActionType["PENDING_PROJECT_GEOFENCE_UPDATE"] = "PendingProjectUpdate";
})(GeoFenceActionType || (GeoFenceActionType = {}));
export var ErrorInfo;
(function (ErrorInfo) {
    ErrorInfo["NAME_ALREADY_EXISTS_ERROR_DESCRIPTION"] = "Error while creating the geofence: Geofence Display Name already exists in the project.";
    ErrorInfo[ErrorInfo["STATUS_CODE_4XX"] = 400] = "STATUS_CODE_4XX";
})(ErrorInfo || (ErrorInfo = {}));
const overlapsGeofencesErrorMessage = " should not overlap with other geofences";
const AddEditGeoFenceForm = ({ activeStep, setActiveStepHandler }) => {
    const { primaryPartyType, setGlobalNotification, userPartyNumber } = useGlobalStore((state) => ({
        primaryPartyType: state.primaryPartyType,
        setGlobalNotification: state.setGlobalNotification,
        userPartyNumber: state.userPartyNumber
    }));
    const { appConfig } = useAppConfigStore((state) => ({
        appConfig: state.appConfig
    }));
    const { projectAddressLat, projectAddressLng, projectId, projectStatus, setCompletedStep, setProjectStatus, setReset } = useNewProjectStore((state) => ({
        projectAddressLat: state.projectAddressLat,
        projectAddressLng: state.projectAddressLng,
        projectId: state.projectId,
        projectStatus: state.projectStatus,
        setCompletedStep: state.setCompletedStep,
        setProjectStatus: state.setProjectStatus,
        setReset: state.setReset
    }));
    const { deleteGeofence, resetGeofenceState, setGeofenceCoordinates, setGeofenceDesc, setGeofenceIdModeType, setGeofenceList, setGeofenceName, setGeofenceType } = useProjectGeoFenceStore((state) => ({
        deleteGeofence: state.deleteGeofence,
        geofenceList: state.geofenceList,
        getGeofenceInfo: state.getGeofenceInfo,
        resetGeofenceState: state.resetGeofenceState,
        setGeofenceCoordinates: state.setGeofenceCoordinates,
        setGeofenceDesc: state.setGeofenceDesc,
        setGeofenceIdModeType: state.setGeofenceIdModeType,
        setGeofenceList: state.setGeofenceList,
        setGeofenceName: state.setGeofenceName,
        setGeofenceType: state.setGeofenceType
    }));
    const CHARACTERS = MIN_GEOFENCE_NAME_LENGTH;
    const [updatedGeoFencePath, setUpdatedGeoFencePath] = useState();
    const [currentPolygonType, setCurrentPolygonType] = useState(POLYGON_TYPES.NONE);
    const [selectedGeoFenceId, setSelectedGeoFenceId] = useState(null);
    const [deleteGeofenceId, setDeleteGeofenceId] = useState(null);
    const [saveUpdateGeofenceInfo, setSaveUpdateGeofenceInfo] = useState(null);
    const [polygonTypeInfo, setPolygonTypeInfo] = useState({
        geofenceId: "",
        polygonType: POLYGON_TYPES.NONE
    });
    const [defaultValuesInfo, setDefaultValuesInfo] = useState();
    const [projectUpdateRequestInfo, setProjectUpdateRequestInfo] = useState();
    const [updateMapPolygonId, setUpdateMapPolygonId] = useState(null);
    const [isModalActive, setIsModalActive] = useState(false);
    useEffect(() => {
        if (defaultValuesInfo) {
            const defaultValues = {
                geoFenceList: defaultValuesInfo ? [...defaultValuesInfo] : []
            };
            reset(defaultValues);
        }
    }, [defaultValuesInfo]);
    useEffect(() => {
        if (saveUpdateGeofenceInfo) {
            const { actionType, geofenceType, newGeofenceId, oldGeoFenceId } = saveUpdateGeofenceInfo;
            const savedGeofence = {
                coordinates: saveUpdateGeofenceInfo.coordinates || [],
                geofenceDesc: saveUpdateGeofenceInfo.geofenceDesc,
                geofenceId: saveUpdateGeofenceInfo?.newGeofenceId || saveUpdateGeofenceInfo.oldGeoFenceId,
                geofenceName: saveUpdateGeofenceInfo.geofenceName || "",
                geofenceType: saveUpdateGeofenceInfo.geofenceType,
                modeType: MODE_TYPE_EDIT
            };
            if (actionType === GeoFenceActionType.PENDING_PROJECT_GEOFENCE_CREATE ||
                actionType === GeoFenceActionType.ACTIVE_PROJECT_GEOFENCE_CREATE) {
                //update temporary geofenceId with newGeofenceId is returned from api
                setGeofenceIdModeType(oldGeoFenceId, newGeofenceId);
                setUpdateMapPolygonId({
                    newGeoFenceId: newGeofenceId,
                    oldGeoFenceId: oldGeoFenceId
                });
                setDefaultValuesInfo((prev) => {
                    return [...(prev || []), { ...savedGeofence, geofenceId: newGeofenceId }];
                });
                setProjectUpdateRequestInfo((prev) => {
                    return [...(prev || []), { geofenceId: newGeofenceId, operationType: GeofenceOperationType.ADD }];
                });
            }
            if (actionType === GeoFenceActionType.PENDING_PROJECT_GEOFENCE_UPDATE ||
                actionType === GeoFenceActionType.ACTIVE_PROJECT_GEOFENCE_UPDATE ||
                actionType === GeoFenceActionType.ACTIVE_PROJECT_GEOFENCE_META_DATA_UPDATE) {
                // For a pending project's geofence info update or an active project's metadata-only update,
                // api returns existing GeoFenceId,not newGeofenceId one
                //gmap and form and local store already has latest data before making api call.
                //so only update deafaultValuesInfo with latest data
                const index = defaultValuesInfo?.findIndex((geofence) => geofence.geofenceId === oldGeoFenceId);
                //update with latest data
                if (index !== -1) {
                    setDefaultValuesInfo((prev) => {
                        const newValues = [...(prev || [])];
                        newValues[index] = { ...savedGeofence, geofenceId: oldGeoFenceId };
                        return newValues;
                    });
                }
            }
            if (actionType === GeoFenceActionType.ACTIVE_PROJECT_GEOFENCE_UPDATE) {
                //update temporary geofenceId with newGeofenceId is returned from api
                setGeofenceIdModeType(oldGeoFenceId, newGeofenceId);
                const index = defaultValuesInfo?.findIndex((geofence) => geofence.geofenceId === oldGeoFenceId);
                if (index !== -1) {
                    setDefaultValuesInfo((prev) => {
                        const newValues = [...(prev || [])];
                        newValues[index] = { ...savedGeofence, geofenceId: newGeofenceId };
                        return newValues;
                    });
                }
                setUpdateMapPolygonId({
                    newGeoFenceId: newGeofenceId,
                    oldGeoFenceId: oldGeoFenceId
                });
                setProjectUpdateRequestInfo((prev) => {
                    return [
                        ...(prev || []),
                        { geofenceId: newGeofenceId, operationType: GeofenceOperationType.EDIT },
                        { geofenceId: oldGeoFenceId, operationType: GeofenceOperationType.DELETE }
                    ];
                });
            }
            if (actionType === GeoFenceActionType.PENDING_PROJECT_GEOFENCE_DELETE) {
                const index = defaultValuesInfo?.findIndex((geofence) => geofence.geofenceId === oldGeoFenceId);
                if (index !== -1) {
                    setDefaultValuesInfo((prev) => {
                        const newValues = [...(prev || [])];
                        newValues.splice(index, 1);
                        return newValues;
                    });
                }
            }
            if (actionType === GeoFenceActionType.ACTIVE_PROJECT_GEOFENCE_DELETE) {
                const index = defaultValuesInfo?.findIndex((geofence) => geofence.geofenceId === oldGeoFenceId);
                if (index !== -1) {
                    if (geofenceType === GeofenceType.PROJECT_AREA) {
                        const allGeofenceIds = defaultValuesInfo.map((geofence) => geofence.geofenceId);
                        const deletesForAll = allGeofenceIds.map((id) => ({
                            geofenceId: id,
                            operationType: GeofenceOperationType.DELETE
                        }));
                        setProjectUpdateRequestInfo((prev) => {
                            return [...(prev || []), ...deletesForAll];
                        });
                        setDefaultValuesInfo([]);
                    }
                    if (geofenceType === GeofenceType.CHARGE_STATION || geofenceType === GeofenceType.JOB_SITE) {
                        setDefaultValuesInfo((prev) => {
                            const newValues = [...(prev || [])];
                            newValues.splice(index, 1);
                            return newValues;
                        });
                        setProjectUpdateRequestInfo((prev) => {
                            return [
                                ...(prev || []),
                                { geofenceId: oldGeoFenceId, operationType: GeofenceOperationType.DELETE }
                            ];
                        });
                    }
                }
            }
            setSaveUpdateGeofenceInfo(null);
        }
    }, [saveUpdateGeofenceInfo]);
    const fillColorSchema = z.object({
        A: z.number().min(0).max(1),
        B: z.number().min(0).max(255),
        G: z.number().min(0).max(255),
        R: z.number().min(0).max(255)
    });
    useEffect(() => {
        if (polygonTypeInfo.geofenceId && polygonTypeInfo.polygonType) {
            setGeofenceType(polygonTypeInfo.geofenceId, polygonTypeInfo.polygonType);
        }
    }, [polygonTypeInfo]);
    useEffect(() => {
        return () => {
            const { pathname } = window.location;
            if (pathname !== CaasRoute.NewProjectPage) {
                setReset();
            }
        };
    }, []);
    const geoFenceSchema = z.object({
        coordinates: z
            .array(z.object({
            lat: z.number().min(-90).max(90),
            lng: z.number().min(-180).max(180)
        }))
            .refine((polygon) => {
            return polygon.length >= 3;
        }, { message: "Geofence must be a valid closed polygon with at least 3 vertices" }),
        fillColor: fillColorSchema.optional(),
        geofenceDesc: z.string().optional(),
        geofenceId: z.string(),
        geofenceName: z.string().superRefine((value, ctx) => {
            const index = ctx.path[1];
            const { geofenceId, modeType } = watch("geoFenceList")?.[index] || {};
            if ((modeType === MODE_TYPE_ADD || modeType === MODE_TYPE_EDIT) && !value) {
                ctx.addIssue({
                    code: z.ZodIssueCode.too_small,
                    inclusive: true,
                    message: `Geofence name is required`,
                    minimum: CHARACTERS,
                    type: "string"
                });
            }
            if (modeType === MODE_TYPE_ADD && value) {
                const exists = defaultValuesInfo?.some((geofence) => geofence.geofenceName === value);
                if (exists) {
                    ctx.addIssue({
                        code: z.ZodIssueCode.custom,
                        message: DUPLICATE_NAME_ERROR
                    });
                }
            }
            if (modeType === MODE_TYPE_EDIT && value) {
                const exists = defaultValuesInfo?.some((geofence) => {
                    return geofence.geofenceName === value && geofence.geofenceId !== geofenceId;
                });
                if (exists) {
                    ctx.addIssue({
                        code: z.ZodIssueCode.custom,
                        message: DUPLICATE_NAME_ERROR
                    });
                }
            }
        }),
        geofenceType: z.enum(["projectArea", "jobSite", "chargeStation", "none"]).refine((val) => {
            if (val === GEOFENCE_TYPE_NONE) {
                return false;
            }
            return true;
        }, {
            message: "Geofence type is required"
        }),
        lineColor: fillColorSchema.optional(),
        modeType: z.enum(["add", "edit"]).default("add")
    });
    const geoFenceListSchema = z.object({
        geoFenceList: z.array(geoFenceSchema).min(1, { message: "At least 3 geofences are required" })
    });
    const { control, formState: { errors, isDirty, isValid }, getValues, handleSubmit, reset, setError, setValue, trigger, watch } = useForm({
        defaultValues: {
            geoFenceList: defaultValuesInfo ? [...defaultValuesInfo] : []
        },
        mode: "onChange",
        resolver: zodResolver(geoFenceListSchema)
    });
    const { fields, prepend, remove } = useFieldArray({
        control,
        name: "geoFenceList"
    });
    const navigate = useNavigate();
    useEffect(() => {
        if (updatedGeoFencePath) {
            const { coordinates, geofenceId } = updatedGeoFencePath;
            const index = getValues("geoFenceList").findIndex((geofenceInfo) => geofenceInfo.geofenceId === geofenceId);
            if (index !== -1 &&
                JSON.stringify(coordinates) !== JSON.stringify(getValues("geoFenceList")?.[index]?.coordinates)) {
                setValue(`geoFenceList.${index}.coordinates`, coordinates, {
                    shouldDirty: true,
                    shouldValidate: true
                });
                setGeofenceCoordinates(geofenceId, coordinates);
            }
        }
    }, [updatedGeoFencePath]);
    useEffect(() => {
        refetch();
    }, []);
    const getAccordionHeaderTitle = (index) => {
        switch (getValues("geoFenceList")?.[index]?.modeType) {
            case MODE_TYPE_ADD:
                return "Add details";
            case MODE_TYPE_EDIT:
                if (getValues("geoFenceList")?.[index]?.geofenceName?.trim().length >= MIN_NAME_DISPLAY_LENGTH) {
                    return getValues("geoFenceList")?.[index]?.geofenceName;
                }
                return "Edit details";
        }
    };
    const triggerSubmit = () => {
        handleSubmit(onSubmit)();
    };
    const queryParamsUpdateProject = {
        ...(userPartyNumber && primaryPartyType !== "CAT" && { partyNumber: userPartyNumber }),
        ...(userPartyNumber && primaryPartyType === "CAT" && { downSelectPartyNumber: userPartyNumber }),
        projectStatus: projectStatus === PROJECT_STATUS_PENDING ? PROJECT_STATUS_ACTIVE : ""
    };
    const { mutate: updateProjectMutate } = useUpdateProjectDetailsMutate(projectId, queryParamsUpdateProject);
    const formatUpdateProjectMutateErrorMessage = (errorMessage) => {
        const isGeofenceOverlapError = errorMessage.match(/^([^()]+)\(/);
        if (isGeofenceOverlapError && errorMessage.includes("(")) {
            return isGeofenceOverlapError[1].trim() + overlapsGeofencesErrorMessage;
        }
        return errorMessage;
    };
    const onSubmit = () => {
        let activeProjectUpdateRequest = {};
        if (projectStatus === PROJECT_STATUS_ACTIVE && projectUpdateRequestInfo?.length > 0) {
            activeProjectUpdateRequest = {
                geofences: projectUpdateRequestInfo
            };
        }
        const projectUpdateRequest = projectStatus === PROJECT_STATUS_PENDING ? {} : activeProjectUpdateRequest;
        const projectActivateMutateParam = {
            onError: (error) => {
                const errorResponse = error.response?.data ||
                    { code: error?.code, description: error?.message };
                const errorMessage = ("data" in errorResponse ? errorResponse.data?.description : errorResponse.description) ||
                    error?.message;
                const errorMessageInfo = formatUpdateProjectMutateErrorMessage(errorMessage);
                setGlobalNotification({
                    message: `${errorMessageInfo}.`,
                    showNotification: true,
                    type: Variant.error
                });
            },
            onSuccess: () => {
                setGlobalNotification({
                    message: `Success. Project has been ${projectStatus === PROJECT_STATUS_PENDING ? "activated" : "updated"} successfully`,
                    showNotification: true,
                    type: Variant.success
                });
                if (appConfig?.release_1_1?.showNewProjectAssetPortfolio) {
                    setCompletedStep(activeStep);
                    if (projectStatus === PROJECT_STATUS_PENDING) {
                        setProjectStatus(PROJECT_STATUS_ACTIVE);
                    }
                    setActiveStepHandler(NewProjectSteps.STEP_THREE);
                }
                else {
                    setCompletedStep(NewProjectSteps.STEP_TWO);
                    navigate(CaasRoute.Home);
                }
            }
        };
        updateProjectMutate(projectUpdateRequest, projectActivateMutateParam);
    };
    const queryParamsProjectGeoFenceInfo = {
        ...(userPartyNumber && primaryPartyType !== "CAT" && { partyNumber: userPartyNumber }),
        ...(userPartyNumber && primaryPartyType === "CAT" && { downSelectPartyNumber: userPartyNumber })
    };
    const { data: projectGeofenceDetailsResponse, refetch } = useGetProjectGeofenceDetailsQuery(projectId, queryParamsProjectGeoFenceInfo);
    useEffect(() => {
        if (projectGeofenceDetailsResponse) {
            const geofenceList = projectGeofenceDetailsResponse?.geofences?.map((geofence) => {
                let coordinates = [];
                if (Array.isArray(geofence.geoBoundary?.coordinates) &&
                    geofence.geoBoundary.coordinates.length > 0) {
                    const rawCoordinates = geofence.geoBoundary.coordinates;
                    const firstPoint = rawCoordinates[0];
                    const lastPoint = rawCoordinates[rawCoordinates.length - 1];
                    const isClosed = rawCoordinates.length > 1 &&
                        firstPoint[0] === lastPoint[0] &&
                        firstPoint[1] === lastPoint[1];
                    const coordinatesToMap = isClosed ? rawCoordinates.slice(0, -1) : rawCoordinates;
                    coordinates = coordinatesToMap.map((coordinate) => ({
                        lat: coordinate[1],
                        lng: coordinate[0]
                    }));
                }
                return {
                    coordinates,
                    description: geofence.description,
                    fillColor: geofence.fillColor,
                    geofenceId: geofence.geofenceId,
                    geofenceName: geofence.geofenceDisplayName || geofence.geofenceName,
                    geofenceStatus: geofence.geofenceStatus,
                    geofenceType: geofence.geofenceType,
                    modeType: MODE_TYPE_EDIT
                };
            }) || [];
            if (geofenceList.length > 0) {
                setGeofenceList(geofenceList);
                const defaultValues = geofenceList.map((gf) => ({
                    coordinates: gf.coordinates || [],
                    fillColor: gf.fillColor,
                    geofenceDesc: gf.description,
                    geofenceId: gf.geofenceId,
                    geofenceName: gf.geofenceName || "",
                    geofenceType: gf.geofenceType,
                    lineColor: gf.lineColor,
                    modeType: MODE_TYPE_EDIT
                }));
                setDefaultValuesInfo(defaultValues);
            }
        }
    }, [projectGeofenceDetailsResponse]);
    const queryParamsGeofenceMutate = {
        ...(userPartyNumber && primaryPartyType !== "CAT" && { partyNumber: userPartyNumber }),
        ...(userPartyNumber && primaryPartyType === "CAT" && { downSelectPartyNumber: userPartyNumber })
    };
    // comment for start mock run
    const { mutate: createGeofenceMutate } = useCreateProjectGeofenceMutate(projectId, queryParamsGeofenceMutate);
    const { mutate: deleteGeofenceMutate } = useDeleteProjectGeofenceMutate(projectId, queryParamsGeofenceMutate);
    const { mutate: updateGeofenceMutate } = useUpdateProjectGeofenceMutate(projectId, queryParamsGeofenceMutate);
    const createGeoFenceHandler = (index, actionType) => {
        const values = getValues(`geoFenceList.${index}`);
        const createGeoFenceRequest = prepareCreateGeoFenceRequest({
            geoFenceCoordinates: values.coordinates,
            geofenceDesc: values.geofenceDesc,
            geofenceName: values.geofenceName,
            geofenceType: values.geofenceType
        });
        const createGeofenceMutateParam = {
            onError: (error) => {
                const errorResponse = error.response?.data ||
                    { code: error?.code, description: error?.message };
                const errorStatus = error?.status || error?.code || "Unknown Error";
                const errorMessage = ("data" in errorResponse ? errorResponse.data?.description : errorResponse.description) ||
                    error?.message;
                setGlobalNotification({
                    message: `Error. ${errorMessage}`,
                    showNotification: true,
                    type: Variant.error
                });
                if (errorStatus === ErrorInfo.STATUS_CODE_4XX &&
                    errorMessage === ErrorInfo.NAME_ALREADY_EXISTS_ERROR_DESCRIPTION) {
                    setError(`geoFenceList.${index}.geofenceName`, {
                        message: "This name already exists. Enter another name.",
                        type: "manual"
                    });
                }
            },
            onSuccess: (data) => {
                const isCreate = actionType === GeoFenceActionType.PENDING_PROJECT_GEOFENCE_CREATE ||
                    actionType === GeoFenceActionType.ACTIVE_PROJECT_GEOFENCE_CREATE;
                setGlobalNotification({
                    message: `Success. ${getGeofenceTypeName(createGeoFenceRequest.geofenceType)} ${createGeoFenceRequest.geofenceDisplayName} has been ${isCreate ? "created" : "updated"}.`,
                    showNotification: true,
                    type: Variant.success
                });
                setSaveUpdateGeofenceInfo({
                    actionType,
                    coordinates: values.coordinates,
                    geofenceDesc: values.geofenceDesc,
                    geofenceName: values.geofenceName,
                    geofenceType: values.geofenceType,
                    newGeofenceId: data.geofenceId,
                    oldGeoFenceId: values.geofenceId
                });
                setValue(`geoFenceList.${index}.geofenceId`, data.geofenceId, { shouldDirty: true });
                setValue(`geoFenceList.${index}.modeType`, MODE_TYPE_EDIT, { shouldDirty: true });
                setSelectedGeoFenceId(null);
            }
        };
        createGeofenceMutate(createGeoFenceRequest, createGeofenceMutateParam);
    };
    const updateGeoFenceHandler = (index, actionType) => {
        const values = getValues(`geoFenceList.${index}`);
        const updateGeofenceInfo = prepareUpdateGeoFenceRequest({
            geoFenceCoordinates: values.coordinates,
            geofenceDesc: values.geofenceDesc,
            geofenceName: values.geofenceName
        });
        const originalGeoFence = defaultValuesInfo?.find((gf) => gf.geofenceId === values.geofenceId);
        if (!originalGeoFence) {
            return;
        }
        const isNameChanged = originalGeoFence.geofenceName !== values.geofenceName;
        const isDescChanged = originalGeoFence.geofenceDesc !== values.geofenceDesc;
        const isCoordinatesChanged = JSON.stringify(originalGeoFence.coordinates) !== JSON.stringify(values.coordinates);
        const updateGeofenceRequest = {
            description: isDescChanged ? updateGeofenceInfo?.description : undefined,
            geoBoundary: isCoordinatesChanged ? updateGeofenceInfo?.geoBoundary : undefined,
            geofenceDisplayName: isNameChanged ? updateGeofenceInfo?.geofenceDisplayName : undefined
        };
        const updateGeofenceMutateParam = {
            onError: (error) => {
                const errorResponse = error.response?.data ||
                    { code: error?.code, description: error?.message };
                const errorStatus = error?.status || error?.code || "Unknown Error";
                const errorMessage = ("data" in errorResponse ? errorResponse.data?.description : errorResponse.description) ||
                    error?.message;
                setGlobalNotification({
                    message: `${errorMessage}.`,
                    showNotification: true,
                    type: Variant.error
                });
                if (errorStatus === ErrorInfo.STATUS_CODE_4XX &&
                    errorMessage === ErrorInfo.NAME_ALREADY_EXISTS_ERROR_DESCRIPTION) {
                    setError(`geoFenceList.${index}.geofenceName`, {
                        message: "This name already exists. Enter another name.",
                        type: "manual"
                    });
                }
            },
            onSuccess: (data) => {
                setGlobalNotification({
                    message: `Success. ${updateGeofenceInfo.geofenceDisplayName} has been updated.`,
                    showNotification: true,
                    type: Variant.success
                });
                //form and local store already has latest data before making api call.
                // so only update deafaultValuesInfo with latest data
                setSaveUpdateGeofenceInfo({
                    actionType,
                    coordinates: values.coordinates,
                    geofenceDesc: values.geofenceDesc,
                    geofenceName: values.geofenceName,
                    geofenceType: values.geofenceType,
                    newGeofenceId: null,
                    oldGeoFenceId: data.geofenceId
                });
                setSelectedGeoFenceId(null);
            }
        };
        updateGeofenceMutate({ geofenceId: values.geofenceId, requestBody: updateGeofenceRequest }, updateGeofenceMutateParam);
    };
    const deletePendingProjectGeoFenceHandler = (index) => {
        const geofenceId = getValues(`geoFenceList.${index}.geofenceId`);
        const geofenceName = getValues(`geoFenceList.${index}.geofenceName`);
        const geofenceType = getValues(`geoFenceList.${index}.geofenceType`);
        const deleteGeofenceMutateParam = {
            onError: (error) => {
                const errorResponse = error.response?.data ||
                    { code: error?.code, description: error?.message };
                const errorMessage = ("data" in errorResponse ? errorResponse.data?.description : errorResponse.description) ||
                    error?.message;
                setGlobalNotification({
                    message: `${errorMessage}.`,
                    showNotification: true,
                    type: Variant.error
                });
            },
            onSuccess: () => {
                setGlobalNotification({
                    message: `Success. ${getGeofenceTypeName(geofenceType)} ${geofenceName} deleted.`,
                    showNotification: true,
                    type: Variant.success
                });
                remove(index);
                deleteGeofence(geofenceId);
                setSaveUpdateGeofenceInfo({
                    actionType: GeoFenceActionType.PENDING_PROJECT_GEOFENCE_DELETE,
                    geofenceType: geofenceType,
                    oldGeoFenceId: geofenceId
                });
                setDeleteGeofenceId({ geofenceId, geofenceType });
            }
        };
        deleteGeofenceMutate(geofenceId, deleteGeofenceMutateParam);
    };
    const checkIsValid = (index) => {
        const values = getValues(`geoFenceList.${index}`);
        const { coordinates, geofenceDesc, geofenceId, geofenceName, geofenceType, modeType } = values;
        if (modeType === MODE_TYPE_ADD) {
            return true;
        }
        //create geofence validation
        const baseValidation = !errors.geoFenceList?.[index]?.geofenceName &&
            !errors.geoFenceList?.[index]?.geofenceType &&
            !errors.geoFenceList?.[index]?.coordinates &&
            !!geofenceName &&
            !!geofenceType &&
            geofenceType !== GEOFENCE_TYPE_NONE &&
            Array.isArray(coordinates) &&
            coordinates.length >= 3;
        //update geofence validation
        if (modeType === MODE_TYPE_EDIT) {
            const originalGeoFence = defaultValuesInfo?.find((gf) => gf.geofenceId === geofenceId);
            if (!originalGeoFence) {
                return false;
            }
            const isNameChanged = originalGeoFence.geofenceName !== geofenceName;
            const isDescChanged = originalGeoFence.geofenceDesc !== geofenceDesc;
            const isCoordinatesChanged = JSON.stringify(originalGeoFence.coordinates) !== JSON.stringify(coordinates);
            const isChanged = isNameChanged || isDescChanged || isCoordinatesChanged;
            return baseValidation && isChanged;
        }
        return baseValidation;
    };
    const checkIsMetaDataOnlyChanged = (index) => {
        const values = getValues(`geoFenceList.${index}`);
        const { geofenceDesc, geofenceName, modeType } = values;
        if (modeType === MODE_TYPE_EDIT && projectStatus === PROJECT_STATUS_ACTIVE) {
            const originalGeoFence = defaultValuesInfo?.find((gf) => gf.geofenceId === values.geofenceId);
            if (!originalGeoFence) {
                return false;
            }
            const isNameChanged = originalGeoFence.geofenceName !== geofenceName;
            const isDescChanged = originalGeoFence.geofenceDesc !== geofenceDesc;
            const isMetaDataChanged = isNameChanged || isDescChanged;
            const isCoordinatesChanged = JSON.stringify(originalGeoFence.coordinates) !== JSON.stringify(values.coordinates);
            if (isCoordinatesChanged) {
                return false;
            }
            return isMetaDataChanged;
        }
    };
    const isGeofenceCoordinatesUpdate = (index) => {
        const values = getValues(`geoFenceList.${index}`);
        const originalGeoFence = defaultValuesInfo?.find((gf) => gf.geofenceId === values.geofenceId);
        if (!originalGeoFence) {
            return false;
        }
        const isCoordinatesChanged = JSON.stringify(originalGeoFence.coordinates) !== JSON.stringify(values.coordinates);
        return isCoordinatesChanged;
    };
    const getActionType = (index) => {
        const modeType = getValues(`geoFenceList.${index}.modeType`);
        if (modeType === MODE_TYPE_ADD && projectStatus === PROJECT_STATUS_PENDING) {
            return GeoFenceActionType.PENDING_PROJECT_GEOFENCE_CREATE;
        }
        else if (modeType === MODE_TYPE_ADD && projectStatus === PROJECT_STATUS_ACTIVE) {
            return GeoFenceActionType.ACTIVE_PROJECT_GEOFENCE_CREATE;
        }
        else if (modeType === MODE_TYPE_EDIT && projectStatus === PROJECT_STATUS_PENDING) {
            return GeoFenceActionType.PENDING_PROJECT_GEOFENCE_UPDATE;
        }
        else if (modeType === MODE_TYPE_EDIT &&
            projectStatus === PROJECT_STATUS_ACTIVE &&
            isGeofenceCoordinatesUpdate(index)) {
            return GeoFenceActionType.ACTIVE_PROJECT_GEOFENCE_UPDATE;
        }
        else if (modeType === MODE_TYPE_EDIT &&
            projectStatus === PROJECT_STATUS_ACTIVE &&
            checkIsMetaDataOnlyChanged(index)) {
            return GeoFenceActionType.ACTIVE_PROJECT_GEOFENCE_META_DATA_UPDATE;
        }
        return null;
    };
    const createUpdateGeoFenceHandler = async (index) => {
        const actionType = getActionType(index);
        if (actionType === GeoFenceActionType.PENDING_PROJECT_GEOFENCE_CREATE ||
            actionType === GeoFenceActionType.ACTIVE_PROJECT_GEOFENCE_CREATE) {
            const isValid = await trigger([
                `geoFenceList.${index}.geofenceName`,
                `geoFenceList.${index}.geofenceType`,
                `geoFenceList.${index}.coordinates`
            ]);
            const coordinates = getValues(`geoFenceList.${index}.coordinates`);
            if (!coordinates ||
                (coordinates?.length === 0 && getValues(`geoFenceList.${index}.geofenceType`) !== "none")) {
                setGlobalNotification({
                    message: "Please draw a valid geofence on map",
                    showNotification: true,
                    type: Variant.warning
                });
            }
            if (!isValid) {
                return;
            }
        }
        if (actionType === GeoFenceActionType.PENDING_PROJECT_GEOFENCE_CREATE ||
            actionType === GeoFenceActionType.ACTIVE_PROJECT_GEOFENCE_CREATE ||
            actionType === GeoFenceActionType.ACTIVE_PROJECT_GEOFENCE_UPDATE) {
            createGeoFenceHandler(index, actionType);
        }
        if (actionType === GeoFenceActionType.PENDING_PROJECT_GEOFENCE_UPDATE ||
            actionType === GeoFenceActionType.ACTIVE_PROJECT_GEOFENCE_META_DATA_UPDATE) {
            updateGeoFenceHandler(index, actionType);
        }
    };
    const isEnabledSubmitButton = () => {
        const geoFenceList = getValues("geoFenceList");
        const hasProjectArea = geoFenceList.some((item) => item.geofenceType === GEOFENCE_TYPE_PROJECT_AREA);
        const hasJobSite = geoFenceList.some((item) => item.geofenceType === GEOFENCE_TYPE_JOB_SITE);
        const hasChargeStation = geoFenceList.some((item) => item.geofenceType === GEOFENCE_TYPE_CHARGE_STATION);
        return !isValid || isDirty || !hasProjectArea || !hasJobSite || !hasChargeStation;
    };
    const getCatListItems = (index) => {
        return (_jsxs(_Fragment, { children: [getValues("geoFenceList").some((item, listItemIndex) => item.geofenceType === GEOFENCE_TYPE_PROJECT_AREA && listItemIndex !== index) ? null : (_jsx(CatListItem, { value: GEOFENCE_TYPE_PROJECT_AREA, children: "Project Area" })), _jsx(CatListItem, { value: GEOFENCE_TYPE_JOB_SITE, children: "Job Site" }), _jsx(CatListItem, { value: GEOFENCE_TYPE_CHARGE_STATION, children: "Charge Station" })] }));
    };
    const isDropDownReadOnly = (index) => {
        const mode = getValues(`geoFenceList.${index}.modeType`);
        if (mode === MODE_TYPE_ADD) {
            return false;
        }
        return mode === MODE_TYPE_EDIT;
    };
    const getActions = (index) => {
        const modeType = getValues("geoFenceList")?.[index]?.modeType;
        const geofenceId = getValues("geoFenceList")?.[index]?.geofenceId;
        const isPanelOpen = selectedGeoFenceId === geofenceId;
        // Show edit icon only when panel is closed and in edit mode
        if (modeType === MODE_TYPE_EDIT && !isPanelOpen) {
            return (_jsxs("div", { className: "flex gap-2 items-center bg-transparent", children: [_jsx(CatIconEdit, { className: "icon-button", "data-test": `edit-geofence-button-${index}`, onClick: () => {
                            setSelectedGeoFenceId(geofenceId);
                        } }), _jsx(CatIconTrash, { className: "icon-button", color: "error", "data-test": `delete-geofence-button-${index}`, onClick: () => {
                            deleteGeoFenceHandler(index);
                        } })] }, `actions-${geofenceId}`));
        }
        return null;
    };
    const deleteGeoFenceHandler = (index) => {
        const modeType = getValues(`geoFenceList.${index}.modeType`);
        if (modeType === MODE_TYPE_EDIT && projectStatus === PROJECT_STATUS_PENDING) {
            deletePendingProjectGeoFenceHandler(index);
        }
        if (modeType === MODE_TYPE_EDIT && projectStatus === PROJECT_STATUS_ACTIVE) {
            const { geofenceId, geofenceType } = getValues(`geoFenceList.${index}`);
            setSaveUpdateGeofenceInfo({
                actionType: GeoFenceActionType.ACTIVE_PROJECT_GEOFENCE_DELETE,
                geofenceType: geofenceType,
                oldGeoFenceId: geofenceId
            });
            setDeleteGeofenceId({ geofenceId, geofenceType });
            if (geofenceType === GEOFENCE_TYPE_PROJECT_AREA) {
                resetGeofenceState();
            }
            else {
                remove(index);
                deleteGeofence(geofenceId);
            }
        }
        if (modeType === MODE_TYPE_ADD) {
            const { geofenceId, geofenceType } = getValues(`geoFenceList.${index}`);
            remove(index);
            deleteGeofence(geofenceId);
            setDeleteGeofenceId({ geofenceId, geofenceType });
        }
    };
    const getButtonName = (index) => {
        const modeType = getValues(`geoFenceList.${index}.modeType`);
        if (modeType === MODE_TYPE_ADD) {
            const name = projectStatus === PROJECT_STATUS_PENDING ? "Save" : "Add Geofence";
            return name;
        }
        if (modeType === MODE_TYPE_EDIT) {
            return "Update";
        }
        return " ";
    };
    const onModalClose = (modalState) => {
        setIsModalActive(modalState);
    };
    const getGeofenceInfoMsg = (index) => {
        const modeType = getValues("geoFenceList")?.[index]?.modeType;
        const geofenceId = getValues("geoFenceList")?.[index]?.geofenceId;
        const isPanelOpen = selectedGeoFenceId === geofenceId;
        const { polygonType = "" } = polygonTypeInfo;
        if (modeType === MODE_TYPE_EDIT && !isPanelOpen) {
            const polygonTypes = [POLYGON_TYPES.JOB_SITE, POLYGON_TYPES.PROJECT_AREA, POLYGON_TYPES.CHARGE_STATION];
            const allPolygonExist = polygonTypes.every((type) => fields.some((g) => g.geofenceType === type));
            if (allPolygonExist) {
                return "Select the geofence to continue. If you need more space, you can return later to adjust the project area.";
            }
            else {
                return (_jsxs(_Fragment, { children: [_jsx("div", { className: "", children: "Please add at least one charging station and Job site:" }), _jsxs("ul", { className: "list-disc pl-2 text-base text-gray-700", children: [_jsxs("li", { children: [_jsx("span", { className: "inline-block align-middle mr-2 w-[6px] h-[6px] bg-gray-500 rounded-full" }), "Job Site and Charge station cannot overlap."] }), _jsxs("li", { children: [_jsx("span", { className: "inline-block align-middle mr-2 w-[6px] h-[6px] bg-gray-500 rounded-full" }), "Job Site and Charge station should be within the Project Area."] })] })] }));
            }
        }
        if (polygonType === POLYGON_TYPES.NONE) {
            return "Select the geofence to continue. If you need more space, you can return later to adjust the project area.";
        }
        else if (polygonType === POLYGON_TYPES.PROJECT_AREA) {
            return "Define the project area before proceeding. All Job Site and charging stations must be placed within project area.";
        }
        else if (polygonType === POLYGON_TYPES.JOB_SITE || polygonType === POLYGON_TYPES.CHARGE_STATION) {
            return (_jsxs(_Fragment, { children: [_jsx("div", { className: "", children: "Please add at least one charging station and Job site:" }), _jsxs("ul", { className: "list-disc pl-2 text-base text-gray-700", children: [_jsxs("li", { children: [_jsx("span", { className: "inline-block align-middle mr-2 w-[6px] h-[6px] bg-gray-500 rounded-full" }), "Job Site and Charge station cannot overlap."] }), _jsxs("li", { children: [_jsx("span", { className: "inline-block align-middle mr-2 w-[6px] h-[6px] bg-gray-500 rounded-full" }), "Job Site and Charge station should be within the Project Area."] })] })] }));
        }
    };
    const getSubmitButtonName = () => {
        const isActive = projectStatus === PROJECT_STATUS_ACTIVE;
        const hasChanges = (projectUpdateRequestInfo?.length ?? 0) > 0;
        if (projectStatus === PROJECT_STATUS_PENDING)
            return "Activate";
        if (isActive) {
            if (hasChanges)
                return "Update";
            const showPortfolio = !!appConfig?.release_1_1?.showNewProjectAssetPortfolio;
            return showPortfolio ? "Next" : "Finish";
        }
        return "Save";
    };
    const onSubmitButtonClick = () => {
        if (projectStatus === PROJECT_STATUS_PENDING ||
            (projectStatus === PROJECT_STATUS_ACTIVE && (projectUpdateRequestInfo?.length ?? 0) > 0)) {
            triggerSubmit();
        }
        else if (projectStatus === PROJECT_STATUS_ACTIVE && (projectUpdateRequestInfo?.length ?? 0) === 0) {
            if (appConfig?.release_1_1?.showNewProjectAssetPortfolio) {
                setCompletedStep(activeStep);
                setActiveStepHandler(NewProjectSteps.STEP_THREE);
            }
            else {
                navigate(CaasRoute.Home);
            }
        }
    };
    return (_jsxs("div", { className: "flex-auto flex flex-col gap-[8px]", children: [_jsxs("div", { className: "flex-auto flex h-[60vh]", children: [_jsx("div", { className: "w-[69%] border-[#CCCCCC] border-t border-l border-b min-h-0 h-full", children: _jsx(GoogleMapGeoFence, { currentSelectedPolygonId: selectedGeoFenceId, currentSelectedPolygonType: currentPolygonType, deletePolygonIdInfo: deleteGeofenceId, latLangValues: { lat: Number(projectAddressLat), lng: Number(projectAddressLng) }, projectGeoFenceInfo: defaultValuesInfo, resetDeletePolygonId: () => {
                                setDeleteGeofenceId(null);
                            }, resetUpdateMapGeoFenceId: () => {
                                setUpdateMapPolygonId(null);
                            }, setSelectedGeoFenceIdInfo: (geofenceId) => setSelectedGeoFenceId(geofenceId), updateGeoFencePath: (geoFencePath) => setUpdatedGeoFencePath(geoFencePath), updatePolygonId: updateMapPolygonId
                                ? {
                                    newGeofenceId: updateMapPolygonId.newGeoFenceId,
                                    oldGeoefnceId: updateMapPolygonId.oldGeoFenceId
                                }
                                : null }) }), _jsxs("div", { className: "w-[31%] flex flex-col gap-[24px] bg-[#F6F6FA] rounded-r-[4px]  border-[#CCCCCC] border px-[16px] py-[16px] relative min-h-0 h-full overflow-y-auto", children: [_jsxs("div", { className: "flex", children: [_jsx("div", { className: "mr-auto", children: _jsx(CatHeading, { "data-test": "geofence-details-heading", variant: "title-sm", children: "Geofence Details" }) }), _jsxs(CatButton, { "data-test": "add-geo-fence-button", disabled: fields.length > 0 ? !isValid || isDirty : false, onClick: () => {
                                            const tempId = `${Date.now()}`;
                                            setSelectedGeoFenceId(tempId);
                                            const geoFenceList = getValues("geoFenceList");
                                            let defaultType = GEOFENCE_TYPE_PROJECT_AREA;
                                            // If NO geofence has 'projectArea', set to projectArea, else set to 'none'
                                            if (geoFenceList.some((item) => item.geofenceType === GEOFENCE_TYPE_PROJECT_AREA)) {
                                                defaultType = GEOFENCE_TYPE_NONE;
                                            }
                                            prepend({
                                                coordinates: [],
                                                geofenceDesc: "",
                                                geofenceId: tempId,
                                                geofenceName: "",
                                                geofenceType: defaultType,
                                                modeType: MODE_TYPE_ADD
                                            });
                                            setGeofenceList([
                                                {
                                                    coordinates: [],
                                                    description: "",
                                                    geofenceId: tempId,
                                                    geofenceName: "",
                                                    geofenceType: defaultType,
                                                    modeType: MODE_TYPE_ADD
                                                }
                                            ]);
                                            setCurrentPolygonType(defaultType === GEOFENCE_TYPE_PROJECT_AREA
                                                ? POLYGON_TYPES.PROJECT_AREA
                                                : POLYGON_TYPES.NONE);
                                            setPolygonTypeInfo({
                                                geofenceId: tempId,
                                                polygonType: defaultType === GEOFENCE_TYPE_PROJECT_AREA
                                                    ? POLYGON_TYPES.PROJECT_AREA
                                                    : POLYGON_TYPES.NONE
                                            });
                                        }, size: "sm", variant: "ghost", children: ["Add", _jsx(CatIconAddCircle, { slot: "after" })] })] }), _jsxs("div", { className: "border-b border-gray-300 pb-4", children: [fields.length <= 0 && (_jsxs("div", { className: "bg-[#f5f5fa] border border-gray-300 rounded p-3 mt-2", children: [_jsx("div", { className: "font-semibold mb-2", "data-test": "geofence-guidelines-heading", children: "GeoFence Guidelines" }), _jsxs("ul", { className: "list-disc pl-2 text-base text-gray-700", children: [_jsxs("li", { children: [_jsx("span", { className: "inline-block align-middle mr-2 w-[6px] h-[6px] bg-gray-500 rounded-full", "data-test": "guideline-charging-station-job-site" }), "Please add at least one charging station and Job Site."] }), _jsxs("li", { children: [_jsx("span", { className: "inline-block align-middle mr-2 w-[6px] h-[6px] bg-gray-500 rounded-full", "data-test": "guideline-project-area" }), "Please add one Project Area."] }), _jsxs("li", { children: [_jsx("span", { className: "inline-block align-middle mr-2 w-[6px] h-[6px] bg-gray-500 rounded-full", "data-test": "guideline-no-overlap" }), "No Two Job Site and Charging Station can overlap."] }), _jsxs("li", { children: [_jsx("span", { className: "inline-block align-middle mr-2 w-[6px] h-[6px] bg-gray-500 rounded-full", "data-test": "guideline-within-project-area" }), "All Job Sites and Charging Stations should be within the Project Area."] })] })] })), fields.length > 0 && (_jsx("div", { className: "bg-[#f5f5fa] border border-gray-300 rounded p-3 mt-2", children: getGeofenceInfoMsg(FIRST_GEOFENCE_INDEX) }))] }), _jsx("div", { className: "relative bg-[#F6F6FA]", children: _jsx("form", { "data-test": "add-edit-geofence-form", onSubmit: (e) => e.preventDefault(), children: _jsx("div", { children: _jsx("div", { children: _jsx(CatAccordion, { "data-testid": "cat-accordion", singlePanelOnly: true, children: _jsx("div", { className: "", children: fields.map((field, index) => (_jsxs("div", { className: "flex flex-row items-center justify-between  border-b min-h-14", children: [_jsx(CatAccordionPanel, { className: "!p-0 !border-none w-full", "data-test": `geofence-accordion-panel-${index}`, isActive: selectedGeoFenceId ===
                                                                    getValues(`geoFenceList.${index}.geofenceId`), onBlAccordionClose: () => {
                                                                    setSelectedGeoFenceId(null);
                                                                }, onBlAccordionOpen: () => {
                                                                    const geofenceId = getValues(`geoFenceList.${index}.geofenceId`);
                                                                    setSelectedGeoFenceId(geofenceId);
                                                                }, children: _jsxs(React.Fragment, { children: [_jsx("div", { slot: "header", children: _jsx("div", { className: "font-normal text-base leading-normal tracking-normal align-middle", "data-test": `geofence-accordion-${index}-header`, children: getAccordionHeaderTitle(index) }) }), _jsxs("div", { className: "flex flex-col gap-4 pt-4", "data-test": `geofence-accordion-${index}-content`, children: [_jsx("div", { children: _jsx(Controller, { control: control, name: `geoFenceList.${index}.geofenceType`, render: ({ field: { onBlur, onChange, value } }) => (_jsx(CatDropdown, { ariaDescribedBy: `geofence-type-${index}`, "data-test": `geofence-type-field-${index}`, fieldId: `geofence-type-${index}`, isReadonly: isDropDownReadOnly(index), label: "Geofence Type", onBlSelect: (e) => {
                                                                                                onChange(e);
                                                                                                if (e.detail.value !== "none") {
                                                                                                    setCurrentPolygonType(e.detail
                                                                                                        .value);
                                                                                                    setPolygonTypeInfo({
                                                                                                        geofenceId: watch(`geoFenceList.${index}.geofenceId`),
                                                                                                        polygonType: e.detail
                                                                                                            .value
                                                                                                    });
                                                                                                }
                                                                                            }, onBlur: onBlur, placeholder: "Select an option...", required: true, value: value, ...(errors.geoFenceList?.[index]
                                                                                                ?.geofenceType && {
                                                                                                errorNote: errors.geoFenceList[index]
                                                                                                    .geofenceType.message,
                                                                                                status: "error"
                                                                                            }), children: _jsx(CatList, { spacing: "padded", children: getCatListItems(index) }) })) }, index) }), _jsx("div", { children: _jsx(Controller, { control: control, defaultValue: "", name: `geoFenceList.${index}.geofenceName`, render: ({ field: { onBlur, onChange, value } }) => (_jsx(CatInputField, { className: "mt-4", "data-test": `geofence-name-field-${index}`, id: `geofence-name-${index}`, label: "Geofence Name", onBlChange: (e) => {
                                                                                                onChange(e);
                                                                                                setGeofenceName(watch(`geoFenceList.${index}.geofenceId`), e.detail.value);
                                                                                            }, onBlur: onBlur, placeholder: "Enter geofence name", required: true, value: value, ...(errors.geoFenceList?.[index]
                                                                                                ?.geofenceName && {
                                                                                                errorNote: errors.geoFenceList?.[index]
                                                                                                    .geofenceName?.message,
                                                                                                status: "error"
                                                                                            }) })) }, field.id) }), _jsx("div", { children: _jsx(Controller, { control: control, defaultValue: "", name: `geoFenceList.${index}.geofenceDesc`, render: ({ field: { onBlur, onChange, value } }) => (_jsx(CatTextareaField, { ariaDescribedBy: `geofence-desc-${index}`, "data-test": `geofence-desc-field-${index}`, label: "Description", onBlChange: (e) => {
                                                                                                onChange(e);
                                                                                                setGeofenceDesc(watch(`geoFenceList.${index}.geofenceId`), e.detail.value);
                                                                                            }, onBlur: onBlur, placeholder: "Enter description", size: "lg", value: value, ...(errors.geoFenceList?.[index]
                                                                                                ?.geofenceDesc && {
                                                                                                errorNote: errors.geoFenceList[index]
                                                                                                    .geofenceDesc.message,
                                                                                                status: "error"
                                                                                            }) })) }, field.id) }), _jsxs("div", { className: "flex gap-2", children: [_jsx(CatButton, { "data-test": `delete-geo-fence-button-${index}`, onClick: () => deleteGeoFenceHandler(index), size: "sm", variant: "ghost", children: getValues(`geoFenceList.${index}.modeType`) ===
                                                                                                "add"
                                                                                                ? "Cancel"
                                                                                                : "Delete" }), _jsx(CatButton, { "data-test": `save-update-geo-fence-button-${index}`, disabled: !checkIsValid(index), onClick: () => {
                                                                                                createUpdateGeoFenceHandler(index);
                                                                                            }, size: "sm", variant: "primary", children: getButtonName(index) })] })] })] }) }), _jsx("div", { className: "flex items-center justify-end gap-4", children: getActions(index) })] }, field.id))) }) }) }) }) }) })] }), _jsx("div", { children: _jsx(NewProjectModal, { onModalClose: onModalClose, showModal: isModalActive }) })] }), _jsxs("div", { className: "flex gap-[8px] justify-end px-[40px]", children: [_jsx(CatButton, { "data-test": "cancel-geofence-form-button", onClick: () => {
                            setIsModalActive(true);
                        }, size: "sm", children: "Cancel" }), _jsx(CatButton, { "data-test": "back-geofence-form-button", onClick: () => {
                            setActiveStepHandler(activeStep - 1);
                        }, size: "sm", variant: "primary", children: "Back" }), _jsx(CatButton, { "data-test": "submit-geofence-form-button", disabled: isEnabledSubmitButton(), onClick: onSubmitButtonClick, size: "sm", variant: "primary", children: getSubmitButtonName() })] })] }));
};
export default AddEditGeoFenceForm;
